module.exports = __webpack_public_path__ + "static/media/add event iconG.d93e6397.svg";